import { isTabInFocus, removeStateFromUrl } from '@shared/utils/utils';
import { PageStateService } from '@shared/user-state/PageStateService';


/**
 * @author NikolaV
 */
export class PageStateLiveUserState<T extends IPageState> {
    handler: IPageStateHandler<T> = null;

    lastState: IPageState = null;
    checkChangeTimer = null;

    constructor(handler: IPageStateHandler<T>) {
        this.handler = handler;
    }

    startPolling = (checkChangeIntervalMS: number) => {
        clearInterval(this.checkChangeTimer);
        this.checkChangeTimer = setInterval(this.save, checkChangeIntervalMS);
    };

    equals(a: IPageState, b: IPageState): boolean {
        return JSON.stringify(a) === JSON.stringify(b);
    }

    restoreState = (page: IPageStatePage) => {
        const req = PageStateService.liveState.fetch(page);
        req.then(state => {
            this.handler.restoreState(state);
        });
        return req;
    }

    save = async () => {
        if (!isTabInFocus()) return;

        const currState = await this.handler.getCurrentState(false);

        if (this.lastState == null) { // first run
            this.lastState = currState;
        }

        if (!this.equals(currState, this.lastState)) {
            PageStateService.liveState.saveOrUpdate(currState)
                .always(() => {
                    this.lastState = currState;

                    // remove share key from url (after the state is changed) so that user can refresh the page normally
                    removeStateFromUrl()
                });
        }
    };

    stopPolling = () => {
        clearInterval(this.checkChangeTimer);
    }
}
